import React from "react";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-[#F9FAFB]"
    >
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-6">
          <div className="max-w-2xl">
            <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#D86C1E] mb-4">
              Real Customers, Real Roofs
            </p>
            <h2 className="font-heading text-4xl sm:text-5xl font-black tracking-tight leading-tight text-[#0A0A0A]">
              What People Say About Working With Schuyler
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-6 w-6 fill-[#D86C1E] text-[#D86C1E]" />
              ))}
            </div>
            <div>
              <div className="font-heading text-2xl font-black text-[#0A0A0A]">4.9 / 5.0</div>
              <div className="text-xs uppercase tracking-wider text-gray-500">
                Across 300+ reviews
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E5E7EB] border border-[#E5E7EB]">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-white p-8 flex flex-col"
            >
              <Quote className="h-8 w-8 text-[#D86C1E] mb-5" />
              <p className="text-[15px] leading-relaxed text-gray-700 flex-1 font-medium">
                "{t.quote}"
              </p>
              <div className="mt-6 pt-6 border-t border-[#E5E7EB] flex items-center justify-between">
                <div>
                  <div className="font-heading font-bold text-[#0A0A0A]">{t.name}</div>
                  <div className="text-xs uppercase tracking-wider text-gray-500">
                    {t.location}
                  </div>
                </div>
                <div className="flex">
                  {[...Array(5)].map((_, j) => (
                    <Star key={j} className="h-3.5 w-3.5 fill-[#D86C1E] text-[#D86C1E]" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
